import React from "react";
import { Col, Row } from "reactstrap";

const KDSLayout = () => {
  return (
    <div className="container-xxl " style={{ minHeight: "100vh" }}>
      <Row>
        <Col
          md={7}
          lg={8}
          className=" d-lg-flex flex-lg-column"
          style={{
            height: "100vh",
          }}
        ></Col>
      </Row>
    </div>
  );
};

export default KDSLayout;
